/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'

import s from './CollectionsHeader.module.css'

function CollectionsHeader({ onChange, searchValue }) {
  return (
    <div className={s.root}>
      <div className={s.title}>Add or remove this apartment to a collection or create new Collection</div>

      <label className={s.label} htmlFor="search">
        Search by name
      </label>
      <input
        className={s.input}
        type="text"
        id="search"
        value={searchValue}
        onChange={(e) => {
          const { value } = e.target
          onChange(value)
        }}
      />
    </div>
  )
}

export default CollectionsHeader
